module.exports = __webpack_public_path__ + "img/slide4.539d5ab5.png";